import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { TextField, RadioGroup, Radio, FormControlLabel, Autocomplete, Checkbox, CircularProgress,} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import QuillComponent from "../../components/common/ReactQuill";
import { createEntity } from "../../apis/apiService";
import {ApprisalFileUpload,} from "../../components/common/FileUpload";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { BtnLoader } from "../../components/common/Loader";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchGetallProjectsQuery,
  useFetchGetallUserListQuery,
} from "../../slice/logdetailSlice";
import dayjs from "dayjs";
import { fetch2factorUsers } from "../../apis/apiService";


export const AddAppraisalFeedback = ({
  onCancel,
  fetchProjects,
  editData = null,
  isEdit = false,
}) => {
  const [uploadedFile, setUploadedFile] = useState([]);
  const [clearFile, setClearFile] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingFileUrls, setExistingFileUrls] = useState([]);

  // States for adding new users/projects
  const [addingNewUser, setAddingNewUser] = useState(false);
  const [addingNewProject, setAddingNewProject] = useState(false);
  const [customUsers, setCustomUsers] = useState([]);
  const [customProjects, setCustomProjects] = useState([]);

  // UserProjectState
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [allProjectOptions, setAllProjectOptions] = useState([]);
  const [selectedUserObject, setSelectedUserObject] = useState(null);
  // const [selectedProjectObject, setSelectedProjectObject] = useState(null);
  const [initialEditValues, setInitialEditValues] = useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);

  const UserNameOptions = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );
  const { data: projectOptions } = useFetchGetallProjectsQuery();
  const { data: allUsers } = useFetchGetallUserListQuery();

  // Use comprehensive user list if available, fallback to Redux state
  const baseUserOptions =
    allUsers && allUsers.length > 0 ? allUsers : UserNameOptions || [];

  // Combine existing users with custom added users
  const userOptions = [...baseUserOptions, ...customUsers];

  /*
    const {
      handleSubmit,
      control,
      reset,
      setValue,
      watch,
      formState: { errors },
    } = useForm({
      defaultValues: {
        userId: "",
        projectId: "",
        feedBackType: "positive",
        dataOfIncident: dayjs(),
        comments: "",
        remarks: "",
        userProfile: "",
      },
      mode: "onChange",
    });
  
    */
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userId: "",
      projectId: "",
      feedBackType: "positive",
      dataOfIncident: dayjs(),
      comments: "",
      remarks: "",
      userProfile: "",
    },
    mode: "onSubmit",          //  CHANGE THIS
    reValidateMode: "onSubmit" //  ADD THIS
  });

  const selectedUserId = watch("userId");
  const selectedProjectId = watch("projectId");
  const feedBackType = watch("feedBackType");
  const comments = watch("comments");
  const remarks = watch("remarks");
  const token = localStorage.getItem("access_token");

  // Initialize form for edit mode
  useEffect(() => {
    if (isEdit && editData && !hasInitialized) {
      // console.log("Initializing edit mode with data:", editData);

      const userId = editData.user_id ? Number(editData.user_id) : "";
      const projectId = editData.project_id ? Number(editData.project_id) : "";
      const feedbackType = (editData.feedback_type || "positive").toLowerCase();
      const incidentDate = editData.date_of_incident
        ? dayjs(editData.date_of_incident)
        : dayjs();
      const commentsValue = editData.comments || "";
      const remarksValue = editData.remarks || "";

      // Store initial values
      setInitialEditValues({
        userId,
        projectId,
        feedBackType: feedbackType,
        dataOfIncident: incidentDate,
        comments: commentsValue,
        remarks: remarksValue,
        userProfile: editData.user_profile || "",
      });

      // Set form values
      setValue("userId", userId);
      setValue("projectId", projectId);
      setValue("feedBackType", feedbackType);
      setValue("dataOfIncident", incidentDate);
      setValue("comments", commentsValue);
      setValue("remarks", remarksValue);
      setValue("userProfile", editData.user_profile || "");

      // Find and set user object
      if (userId) {
        const userObj = userOptions.find((u) => u.user_id === userId);
        setSelectedUserObject(userObj || null);
        // Fetch projects for this user
        getUserAccessedProject(userId);
      }

      // Find and set project object
      // if (projectId) {
      //   // Check in all available projects
      //   let projectObj = projectOptions?.find(
      //     (p) => p.project_id === projectId
      //   );
      //   if (!projectObj) {
      //     projectObj = customProjects.find((p) => p.project_id === projectId);
      //   }
      //   setSelectedProjectObject(projectObj || null);
      // }

      // Find and set project object
      // if (projectId) {
      //   console.log("Looking for project with ID:", projectId);
      //   console.log("Project options:", projectOptions);
      //   console.log("Custom projects:", customProjects);

      //   // Check in projectOptions from API
      //   let projectObj = projectOptions?.find(
      //     (p) => Number(p.project_id) === Number(projectId)
      //   );

      //   // If not found, check in customProjects
      //   if (!projectObj) {
      //     projectObj = customProjects.find(
      //       (p) => Number(p.project_id) === Number(projectId)
      //     );
      //   }

      //   // If still not found, create a basic object with the ID and name
      //   if (!projectObj && editData.project_name) {
      //     projectObj = {
      //       project_id: projectId,
      //       title: editData.project_name
      //     };
      //   } else if (!projectObj) {
      //     // Last resort - just show the ID
      //     projectObj = {
      //       project_id: projectId,
      //       title: `Project ID: ${projectId}`
      //     };
      //   }

      //   console.log("Setting selected project object:", projectObj);
      //   setSelectedProjectObject(projectObj);
      // }

      // Handle existing image evidence - IMPORTANT FIX
      if (editData?.image_evidence) {
        let existingFiles = [];
        let existingUrls = [];

        if (Array.isArray(editData.image_evidence)) {
          editData.image_evidence.forEach((item) => {
            if (item && item.url) {
              existingFiles.push({
                name: item.url?.split("/").pop() || "evidence-file",
                url: item.url,
                preview: item.url,
                isExisting: true, // Mark as existing file
                id: item.url, // Use URL as ID for tracking
              });
              existingUrls.push(item.url); // Store URL separately
            }
          });
        }

        // console.log("Setting existing files:", existingFiles);
        setUploadedFile(existingFiles);
        setExistingFileUrls(existingUrls); // Store URLs for reference
        setValue("image_evidence", existingFiles);
      } else {
        setUploadedFile([]);
        setExistingFileUrls([]);
        setValue("image_evidence", []);
      }

      setHasInitialized(true);
    } else if (!isEdit && hasInitialized) {
      // Reset for new form
      reset({
        userId: "",
        projectId: "",
        feedBackType: "positive",
        dataOfIncident: dayjs(),
        comments: "",
        remarks: "",
        userProfile: "",
      });
      setSelectedUserObject(null);
      // setSelectedProjectObject(null);
      setUploadedFile([]);
      setExistingFileUrls([]); // Reset existing URLs
      setAllProjectOptions([]);
      setHasInitialized(false);
      setInitialEditValues(null);
    }
  }, [
    isEdit,
    editData,
    setValue,
    reset,
    userOptions,
    projectOptions,
    customProjects,
    hasInitialized,
  ]);

  // Comments filed required
  //   const {
  //   setError,
  //   clearErrors,
  // } = useForm();

  // Fixed filtered record after reopen and fetched 


  // Function to add new user
  const addNewUser = async (userName) => {
    if (!userName.trim()) return null;

    try {
      setAddingNewUser(true);

      const existingUser = userOptions.find(
        (user) => user.name.toLowerCase() === userName.toLowerCase()
      );

      if (existingUser) {
        toast.info(`User "${userName}" already exists`);
        return existingUser.user_id;
      }

      const response = await axios.post(
        "users/create",
        { name: userName },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        const newUser = {
          user_id: response.data.data.user_id || Date.now(),
          name: userName,
          email: "",
        };

        setCustomUsers((prev) => [...prev, newUser]);

        const storedUsers = JSON.parse(
          localStorage.getItem("customUsers") || "[]"
        );
        storedUsers.push(newUser);
        localStorage.setItem("customUsers", JSON.stringify(storedUsers));

        toast.success(`User "${userName}" added successfully`);
        return newUser.user_id;
      } else {
        throw new Error(response.data.message || "Failed to add user");
      }
    } catch (error) {
      console.error("Error adding user:", error);

      const tempUser = {
        user_id: Date.now(),
        name: userName,
        email: "",
      };

      setCustomUsers((prev) => [...prev, tempUser]);

      const storedUsers = JSON.parse(
        localStorage.getItem("customUsers") || "[]"
      );
      storedUsers.push(tempUser);
      localStorage.setItem("customUsers", JSON.stringify(storedUsers));

      toast.info(`User "${userName}" added locally`);
      return tempUser.user_id;
    } finally {
      setAddingNewUser(false);
    }
  };

  // Function to add new project
  const addNewProject = async (projectName) => {
    if (!projectName.trim()) return null;

    try {
      setAddingNewProject(true);

      const existingProject = projectOptions?.find(
        (project) => project.title.toLowerCase() === projectName.toLowerCase()
      );

      if (existingProject) {
        toast.info(`Project "${projectName}" already exists`);
        return existingProject.project_id;
      }

      const response = await axios.post(
        "projects/create",
        { title: projectName },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        const newProject = {
          project_id: response.data.data.project_id || Date.now(),
          title: projectName,
        };

        setCustomProjects((prev) => [...prev, newProject]);

        const storedProjects = JSON.parse(
          localStorage.getItem("customProjects") || "[]"
        );
        storedProjects.push(newProject);
        localStorage.setItem("customProjects", JSON.stringify(storedProjects));

        toast.success(`Project "${projectName}" added successfully`);
        return newProject.project_id;
      } else {
        throw new Error(response.data.message || "Failed to add project");
      }
    } catch (error) {
      console.error("Error adding project:", error);

      const tempProject = {
        project_id: Date.now(),
        title: projectName,
      };

      setCustomProjects((prev) => [...prev, tempProject]);

      const storedProjects = JSON.parse(
        localStorage.getItem("customProjects") || "[]"
      );
      storedProjects.push(tempProject);
      localStorage.setItem("customProjects", JSON.stringify(storedProjects));

      toast.info(`Project "${projectName}" added locally`);
      return tempProject.project_id;
    } finally {
      setAddingNewProject(false);
    }
  };

  // Load custom users/projects from localStorage on component mount
  useEffect(() => {
    const storedUsers = JSON.parse(localStorage.getItem("customUsers") || "[]");
    const storedProjects = JSON.parse(
      localStorage.getItem("customProjects") || "[]"
    );

    if (storedUsers.length > 0) {
      setCustomUsers(storedUsers);
    }
    if (storedProjects.length > 0) {
      setCustomProjects(storedProjects);
    }
  }, []);

  // Combine existing projects with custom added projects
  const combinedProjectOptions = [...(projectOptions || []), ...customProjects];

  const isQuillEmpty = (value) => {
    if (!value) return true;
    const text = value.replace(/<(.|\n)*?>/g, "").trim();
    return text.length === 0;
  };


  const onSubmit = async (data) => {
    // console.log("Form submitted data:", data);
    // console.log("Uploaded files:", uploadedFile);

    // Required validations
    // if (!data.userId || data.userId === "") {
    //   toast.error("Please select or enter a user");
    //   return;
    // }

    if (!data.projectId || data.projectId === "") {
      toast.error("Please select a project");
      return;
    }

    // ADD MODE → comments required

    // COMMENTS REQUIRED (Add & Edit)
    if (!data.comments || isQuillEmpty(data.comments)) {
      toast.error("Comments field is required");
      return;
    }

    if (!data.dataOfIncident) {
      toast.error("Date of incident is required");
      return;
    }

    if (!dayjs(data.dataOfIncident).isValid()) {
      toast.error("Please enter a valid date format");
      return;
    }

    let userId = data.userId;
    let userNameForNewUser = null;

    if (typeof userId === "string") {
      if (!isNaN(Number(userId)) && userId.trim() !== "") {
        userId = Number(userId);
      } else {
        const foundUser = userOptions?.find(
          (u) => u.name.toLowerCase() === userId.toLowerCase().trim()
        );
        if (foundUser) {
          userId = foundUser.user_id;
        } else {
          userNameForNewUser = userId.trim();
        }
      }
    }

    let projectId = data.projectId;
    let projectNameForNewProject = null;

    if (typeof projectId === "string") {
      if (!isNaN(Number(projectId)) && projectId.trim() !== "") {
        projectId = Number(projectId);
      } else {
        const foundProject = combinedProjectOptions?.find(
          (p) =>
            p.title.toLowerCase() === projectId.toLowerCase().trim()
        );
        if (foundProject) {
          projectId = foundProject.project_id;
        } else {
          projectNameForNewProject = projectId.trim();
        }
      }
    }

    if (userNameForNewUser) {
      const newUserId = await addNewUser(userNameForNewUser);
      if (!newUserId) return;
      userId = newUserId;
    }

    if (projectNameForNewProject) {
      const newProjectId = await addNewProject(projectNameForNewProject);
      if (!newProjectId) return;
      projectId = newProjectId;
    }

    if (!userId || !projectId) {
      toast.error("Please select valid user and project");
      return;
    }

    const requestData = new FormData();

    requestData.append("user_id", Number(userId));
    requestData.append("project_id", Number(projectId));
    requestData.append("feedback_type", data.feedBackType.toLowerCase());

    const formattedDate = dayjs(data.dataOfIncident).format("YYYY-MM-DD");
    requestData.append("date_of_incident", formattedDate);

    //  MAIN FIX — ALWAYS SEND COMMENTS
    // const finalComments =
    //   isEdit && (!data.comments || data.comments.trim() === "")
    //     ? initialEditValues?.comments || ""
    //     : data.comments;

    const finalComments =
      isEdit && (!data.comments || data.comments.trim() === "")
        ? initialEditValues?.comments || ""
        : data.comments;

    requestData.append("comments", finalComments);


    const cleanComments = data.comments.replace(/<(.|\n)*?>/g, "").trim();
    requestData.append("comments", data.comments);
    requestData.append("clean_comments", cleanComments);

    requestData.append("remarks", data.remarks || "");

    // Edit mode ID
    if (isEdit && editData) {
      const feedbackId =
        editData.appraisal_feedback_id || editData.id;
      if (!feedbackId) {
        toast.error("Feedback ID not found");
        return;
      }
      requestData.append("appraisal_feedback_id", feedbackId);
    }

    // Images
    if (uploadedFile.length > 0) {
      uploadedFile.forEach((file, index) => {
        if (file.isExisting && file.url) {
          requestData.append(
            `existing_image_evidence[${index}]`,
            file.url
          );
        } else if (file instanceof File) {
          requestData.append(`image_evidence[${index}]`, file);
        } else if (file.originFileObj) {
          requestData.append(
            `image_evidence[${index}]`,
            file.originFileObj
          );
        } else if (file.raw) {
          requestData.append(`image_evidence[${index}]`, file.raw);
        }
      });
    }

    setIsSubmitting(true);
    try {
      const response = await createEntity( "appraisalFeedback/createOrUpdateAppraisalFeedback", requestData);
      if (response?.status) {
        toast.success(
          isEdit
            ? "Appraisal Feedback updated successfully!"
            : "Appraisal Feedback created successfully!"
        );

        await fetchProjects();
        onCancel();
      }
      else {
        toast.error(response?.message || "Operation failed");
      }
    } 
    catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Operation failed"
      );
    }
    finally {
      setIsSubmitting(false);
    }
  };


  // USER → PROJECT API
  // const getUserAccessedProject = async (userId) => {
  //   try {
  //     setLoadingProjects(true);
  //     const url = `getUserAccessedProject/${userId}`;
  //     const response = await fetch2factorUsers(url, token);
  //     setAllProjectOptions(response.data || []);
  //   } catch (error) {
  //     console.error("Error fetching projects:", error);
  //     setAllProjectOptions([]);
  //   } finally {
  //     setLoadingProjects(false);
  //   }
  // };

  const latestUserRef = useRef(null);

  const getUserAccessedProject = async (userId) => {
    const requestId = Date.now(); // Generate unique ID for this request
    latestUserRef.current = { id: userId, requestId };

    try {
      setLoadingProjects(true);

      const url = `getUserAccessedProject/${userId}`;
      const response = await fetch2factorUsers(url, token);

      // Only update if this is still the latest request
      if (latestUserRef.current?.id === userId &&
        latestUserRef.current?.requestId === requestId) {
        setAllProjectOptions(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      if (latestUserRef.current?.id === userId) {
        setAllProjectOptions([]);
      }
    } finally {
      if (latestUserRef.current?.id === userId) {
        setLoadingProjects(false);
      }
    }
  };

  // Use the same hook as FilterProjectComponent for project-based users
  const { data: projectBasedUsersData } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedProjectId, {
      skip: !selectedProjectId,
    });

  // Get final user options - filtered by project if project is selected
  const getFinalUserOptions = () => {
    if (selectedProjectId && projectBasedUsersData) {
      return projectBasedUsersData;
    }
    return userOptions;
  };
  /*
  const getFinalUserOptions = () => {
  // Manager check
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userRole = currentUser?.user_role?.toLowerCase();
  const isManager = userRole === 'manager' || userRole === 'projectmanager';
  
  // For manager - return empty array (no users)
  if (isManager) {
    return [];
  }
  
  // For non-manager - existing logic
  if (selectedProjectId && projectBasedUsersData) {
    return projectBasedUsersData;
  }
  return userOptions;
};

const getFinalProjectOptions = () => {
  // Manager check
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userRole = currentUser?.user_role?.toLowerCase();
  const isManager = userRole === 'manager' || userRole === 'projectmanager';
  
  // For manager - only show projects from getUserAccessedProject
  if (isManager) {
    if (selectedUserId) {
      if (loadingProjects) return [];
      return allProjectOptions;
    }
    return []; // No projects until user selected
  }
  
  // For non-manager - existing logic
  if (selectedUserId) {
    if (loadingProjects) return [];
    return allProjectOptions;
  }
  return combinedProjectOptions;
};
*/

  // Get final project options - filtered by user if user is selected
  // const getFinalProjectOptions = () => {
  //   if (selectedUserId && allProjectOptions.length > 0) {
  //     return allProjectOptions;
  //   }
  //   return combinedProjectOptions;
  // };

  //   const getFinalProjectOptions = () => {
  //   // If user selected
  //   if (selectedUserId) {
  //     // While loading → show empty (prevent showing all projects)
  //     if (loadingProjects) {
  //       return [];
  //     }

  //     // After loaded → show only user projects
  //     return allProjectOptions;
  //   }

  //   // If no user selected → show all projects
  //   return combinedProjectOptions;
  // };

  // const getFinalProjectOptions = () => {
  //   if (selectedUserId) {
  //     if (loadingProjects) return [];
  //     return allProjectOptions;
  //   }
  //   return combinedProjectOptions;
  // };

  // const getFinalProjectOptions = () => {
  //   if (selectedUserId) {
  //     if (loadingProjects) return [];
  //     return allProjectOptions;
  //   }
  //   return combinedProjectOptions;
  // };

  const getFinalProjectOptions = () => {
    if (selectedUserId) {
      if (loadingProjects) {
        // Return empty array while loading
        return [];
      }
      return allProjectOptions;
    }
    return combinedProjectOptions;
  };
  /*
  const getFinalProjectOptions = () => {
    // Manager check
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userRole = currentUser?.user_role?.toLowerCase();
    const isManager = userRole === 'manager' || userRole === 'projectmanager';
    
    // For manager - only show projects from getUserAccessedProject
    if (isManager) {
      if (selectedUserId) {
        if (loadingProjects) return [];
        return allProjectOptions;
      }
      return []; // No projects until user selected
    }
    
    // For non-manager - existing logic
    if (selectedUserId) {
      if (loadingProjects) return [];
      return allProjectOptions;
    }
    return combinedProjectOptions;
  };
  */

  //   useEffect(() => {
  //   if (selectedUserId && !isEdit) {
  //     setAllProjectOptions([]);   // Clear immediately
  //     setLoadingProjects(true);   // Show loader immediately
  //     getUserAccessedProject(selectedUserId);
  //     setSelectedProjectObject(null);
  //   }
  // }, [selectedUserId, isEdit]);

  // useEffect(() => {
  //   if (selectedUserId && !isEdit) {
  //     setValue("projectId", "");
  //     setSelectedProjectObject(null);
  //     setAllProjectOptions([]);

  //     getUserAccessedProject(selectedUserId);
  //   }
  // }, [selectedUserId]);

  // useEffect(() => {
  //   if (selectedUserId && !isEdit) {
  //     setValue("projectId", "");
  //     setAllProjectOptions([]);
  //     getUserAccessedProject(selectedUserId);
  //   }
  // }, [selectedUserId]);
  useEffect(() => {
    if (!isEdit) {
      // Always clear project selection when user changes
      setValue("projectId", "", { shouldValidate: false });

      // Clear existing project options immediately
      setAllProjectOptions([]);

      // Fetch new projects if a user is selected
      if (selectedUserId) {
        // Small delay to ensure UI updates before loading
        setTimeout(() => {
          getUserAccessedProject(selectedUserId);
        }, 0);
      }
    }
  }, [selectedUserId, isEdit, setValue]);


  // useEffect(() => {
  //   if (selectedProjectId && !isEdit) {
  //     setSelectedUserObject(null);
  //   }
  // }, [selectedProjectId, isEdit]);

  // Handle user selection
  const handleUserSelect = (newValue) => {
    // console.log("User selection:", newValue);

    if (typeof newValue === "string") {
      setValue("userId", newValue);
      setSelectedUserObject({ name: newValue });
    } else if (newValue && newValue.user_id) {
      setValue("userId", newValue.user_id);
      setSelectedUserObject(newValue);
    } else {
      setValue("userId", "");
      setSelectedUserObject(null);
    }
  };

  // Handle project selection
  // const handleProjectSelect = (newValue) => {
  //   console.log("Project selection:", newValue);

  //   if (typeof newValue === "string") {
  //     setValue("projectId", newValue);
  //     setSelectedProjectObject({ title: newValue });
  //   } else if (newValue && newValue.project_id) {
  //     setValue("projectId", newValue.project_id);
  //     setSelectedProjectObject(newValue);
  //   } else {
  //     setValue("projectId", "");
  //     setSelectedProjectObject(null);
  //   }
  // };

  // Handle project selection
  // const handleProjectSelect = (newValue) => {
  //   console.log("Project selection:", newValue);

  //   if (typeof newValue === "string") {
  //     setValue("projectId", newValue);
  //     setSelectedProjectObject({ title: newValue });
  //   } else if (newValue && (newValue.project_id || newValue.id)) {
  //     // Handle both project_id and id properties
  //     const projectId = newValue.project_id || newValue.id;
  //     setValue("projectId", projectId);
  //     setSelectedProjectObject(newValue);
  //   } else {
  //     setValue("projectId", "");
  //     setSelectedProjectObject(null);
  //   }
  // };

  // Helper to normalize project objects
  // const normalizeProjectObject = (project) => {
  //   if (!project) return null;

  //   if (typeof project === 'object') {
  //     return {
  //       project_id: project.project_id || project.id,
  //       title: project.title || project.name || `Project ${project.project_id || project.id}`
  //     };
  //   }
  //   return null;
  // };


  // const handleFileChange = (files) => {
  //   if (!files || files.length === 0) {
  //     setUploadedFile([]);
  //     setValue("image_evidence", []);
  //     return;
  //   }

  //   let filesArray;
  //   if (files instanceof FileList) {
  //     filesArray = Array.from(files);
  //   } else if (Array.isArray(files)) {
  //     filesArray = files;
  //   } else {
  //     filesArray = [files];
  //   }

  //   const MAX_SIZE = 2 * 1024 * 1024; // 2MB

  //   const ALLOWED_TYPES = [
  //     "image/jpeg",
  //     "image/png",
  //     "image/jpg",
  //     "image/gif",
  //     "image/svg+xml",
  //   ];

  //   const validFiles = [];

  //   for (let file of filesArray) {

  //     // If file is from backend (already uploaded)
  //     if (!(file instanceof File)) {
  //       validFiles.push(file);
  //       continue;
  //     }

  //     // Block unsupported types
  //     if (!ALLOWED_TYPES.includes(file.type)) {
  //       toast.error("Unsupported file format");
  //       continue;
  //     }

  //     // Block large file
  //     if (file.size > MAX_SIZE) {
  //       toast.error("File size should not exceed 2MB");
  //       continue;
  //     }

  //     validFiles.push(file);
  //   }

  //   setUploadedFile(validFiles);
  //   setValue("image_evidence", validFiles);
  // };

  //today------------------

  // Calculate total size in MB
  // Convert bytes to proper KB / MB format

  // const formatFileSize = (bytes) => {
  //   const kb = bytes / 1024;
  //   const mb = bytes / (1024 * 1024);

  //   if (mb >= 1) {
  //     return `${mb.toFixed(2)} MB`;
  //   } else {
  //     return `${kb.toFixed(2)} KB`;
  //   }
  // };

  // // Total size in bytes
  // const totalBytes = uploadedFile.reduce((acc, file) => {
  //   if (file instanceof File) {
  //     return acc + file.size;
  //   }
  //   return acc;
  // }, 0);

  // const formattedTotalSize = formatFileSize(totalBytes);


  //today------------------

  // const handleFileChange = (files) => {
  //   if (!files || files.length === 0) {
  //     setUploadedFile([]);
  //     setValue("image_evidence", []);
  //     return;
  //   }

  //   let filesArray;
  //   if (files instanceof FileList) {
  //     filesArray = Array.from(files);
  //   } else if (Array.isArray(files)) {
  //     filesArray = files;
  //   } else {
  //     filesArray = [files];
  //   }

  //   const SINGLE_MAX_SIZE = 2 * 1024 * 1024; // 2MB
  //   const MULTIPLE_TOTAL_MAX_SIZE = 10 * 1024 * 1024; // 10MB

  //   const ALLOWED_TYPES = [
  //     "image/jpeg",
  //     "image/png",
  //     "image/jpg",
  //     "image/gif",
  //     "image/svg+xml",
  //   ];

  //   const validFiles = [];
  //   let totalSize = 0;

  //   for (let file of filesArray) {

  //     if (!(file instanceof File)) {
  //       validFiles.push(file);
  //       continue;
  //     }

  //     // Type check
  //     if (!ALLOWED_TYPES.includes(file.type)) {
  //       toast.error("Unsupported file format");
  //       continue;
  //     }

  //     // Single image check
  //     if (filesArray.length === 1 && file.size > SINGLE_MAX_SIZE) {
  //       toast.error("Single image size should not exceed 2MB");
  //       continue;
  //     }

  //     totalSize += file.size;
  //     validFiles.push(file);
  //   }

  //   // Multiple images total size check
  //   if (filesArray.length > 1 && totalSize > MULTIPLE_TOTAL_MAX_SIZE) {
  //     toast.error("Total size of multiple images should not exceed 10MB");
  //     return;
  //   }

  //   setUploadedFile(validFiles);
  //   setValue("image_evidence", validFiles);
  // };

  const handleFileChange = (files) => {
    if (!files || files.length === 0) {
      setUploadedFile([]);
      setValue("image_evidence", []);
      return;
    }

    let filesArray;
    if (files instanceof FileList) {
      filesArray = Array.from(files);
    } else if (Array.isArray(files)) {
      filesArray = files;
    } else {
      filesArray = [files];
    }

    const MAX_SIZE = 2 * 1024 * 1024; // 2MB for both single & multiple

    const ALLOWED_TYPES = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/gif",
      "image/svg+xml",
    ];

    const validFiles = [];

    for (let file of filesArray) {

      if (!(file instanceof File)) {
        validFiles.push(file);
        continue;
      }

      // Type check
      if (!ALLOWED_TYPES.includes(file.type)) {
        toast.error("Unsupported file format");
        continue;
      }

      //  Size check (applies to every file)
      if (file.size > MAX_SIZE) {
        toast.error("Image size should not exceed 2MB");
        continue;
      }

      validFiles.push(file);
    }

    setUploadedFile(validFiles);
    setValue("image_evidence", validFiles);
  };

  const removeImage = (index) => {
    // console.log("Removing image at index:", index, "Current files:", uploadedFile);

    if (!uploadedFile || uploadedFile.length === 0) return;

    // Create a new array without the file at the specified index
    const updatedFiles = uploadedFile.filter((_, i) => i !== index);

    // console.log("Updated files after removal:", updatedFiles);

    // Update state
    setUploadedFile(updatedFiles);
    setValue("image_evidence", updatedFiles);

    // If you need to clear the file from the FileUpload component
  };

  useEffect(() => {
    if (isEdit && editData?.image_evidence) {
      setUploadedFile(editData.image_evidence);
      setValue("image_evidence", editData.image_evidence);
    }
  }, [isEdit, editData]);

  const openImageFilePicker = (onChange) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;

    // Changed to allow all files
    // input.accept = '*/*';
    input.accept = 'image/jpeg,image/jpg,image/png,image/gif,image/svg+xml';


    input.onchange = (e) => {
      const files = Array.from(e.target.files || []);

      // Additional validation to ensure only images are processed
      const imageFiles = files.filter(file => {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/svg+xml'];
        return validTypes.includes(file.type);
      });

      if (imageFiles.length !== files.length) {
        toast.warning('Only image files are allowed.');
      }

      if (imageFiles.length > 0) {
        onChange(imageFiles);
      }
    };

    input.click();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center form-label">
            <IoIosArrowBack className="me-1" />
            {isEdit ? "Edit Appraisal Feedback" : "Add Appraisal Feedback"}
          </div>
        </button>
      </div>
      <div className="bg-white pb-5 pt-3 px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              {/* USER SELECTION */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label">
                    User <span className="text-rgbr-red"> *</span>
                  </label>

                  <Controller
                    name="userId"
                    control={control}
                    rules={{ required: "User is required" }}
                    render={({ field, fieldState }) => (
                      <Autocomplete
                        freeSolo
                        options={getFinalUserOptions()}
                        getOptionLabel={(option) =>
                          typeof option === "string" ? option : option?.name || ""
                        }
                        value={
                          getFinalUserOptions().find(
                            (u) => u.user_id === field.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          let value = "";

                          if (!newValue) value = "";
                          else if (typeof newValue === "string") value = newValue;
                          else value = newValue.user_id;

                          field.onChange(value);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{typeof option === "string" ? option : option?.name || ""}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select User"
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                          />
                        )}
                      />
                    )}
                  />
                </div>
              </div>

              {/* PROJECT SELECTION */}
              {/* <div className="row mb-3">
                <div className="col-md-12 mt-2">
                  <label htmlFor="project-id" className="from-label mb-2">
                    Project <span className="text-rgbr-red"> *</span>
                  </label>
<Controller
  name="projectId"
  control={control}
  rules={{ required: "Project is required" }}
  render={({ field, fieldState }) => (
    <Autocomplete
      key={`project-select-${selectedUserId || 'no-user'}-${Date.now()}`} 
      freeSolo
      options={getFinalProjectOptions()}
      getOptionLabel={(option) =>
        typeof option === "string"
          ? option
          : option?.title || ""
      }
      value={
        getFinalProjectOptions().find(
          (p) => p.project_id === field.value
        ) || null
      }
      onChange={(event, newValue) => {
        let value = "";

        if (!newValue) value = "";
        else if (typeof newValue === "string") value = newValue;
        else value = newValue.project_id;

        field.onChange(value);
      }}
      loading={loadingProjects}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Project"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingProjects && (
                  <CircularProgress size={20} />
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )}
/>
                </div>
              </div> */}

              {/* PROJECT SELECTION */}
              <div className="row mb-3">
                <div className="col-md-12 mt-2">
                  <label htmlFor="project-id" className="from-label mb-2">
                    Project <span className="text-rgbr-red"> *</span>
                  </label>
                  <Controller
                    name="projectId"
                    control={control}
                    rules={{ required: "Project is required" }}
                    render={({ field, fieldState }) => (
                      <Autocomplete
                        key={`project-select-${selectedUserId || 'no-user'}`}
                        freeSolo
                        options={getFinalProjectOptions()}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.title || ""
                        }
                        value={
                          getFinalProjectOptions().find(
                            (p) => p.project_id === field.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          let value = "";

                          if (!newValue) value = "";
                          else if (typeof newValue === "string") value = newValue;
                          else value = newValue.project_id;

                          field.onChange(value);
                        }}
                        loading={loadingProjects}
                        // Enabled in edit mode regardless of userId to allow interaction if data is present
                        disabled={!selectedUserId && !isEdit}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{typeof option === "string" ? option : option?.title || ""}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={loadingProjects ? "Loading projects..." : (!selectedUserId && !isEdit) ? "Select a user first" : "Select Project"}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingProjects && (
                                    <CircularProgress size={20} />
                                  )}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </div>
              </div>

              {/* FEEDBACK TYPE */}
              <div className="row mb-3">
                <div className="col-md-12 d-flex align-items-center mt-2">
                  <div className="me-3">
                    <label
                      htmlFor="feedbackType"
                      className="from-label "
                    >
                      Feedback Type <span className="text-rgbr-red"> *</span>
                    </label>
                  </div>
                  <div>
                    <Controller
                      name="feedBackType"
                      control={control}
                      rules={{ required: "Feedback type is required" }}
                      render={({ field }) => (
                        <RadioGroup
                          row
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                          }}
                        >
                          <FormControlLabel
                            value="positive"
                            control={<Radio />}
                            label="Positive"
                          />
                          <FormControlLabel
                            value="negative"
                            control={<Radio />}
                            label="Negative"
                          />
                        </RadioGroup>
                      )}
                    />
                    {errors.feedBackType && (
                      <span className="errorMsg">
                        {errors.feedBackType.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* DATE OF INCIDENT */}
              <div className="row mb-3">
                <div className="col-md-5">
                  <label htmlFor="startDate" className="from-label ">
                    Date Of Incident <span className="text-rgbr-red"> *</span>
                  </label>
                  {/* <div className="date-of-incident d-flex flex-column mt-2 w-full"> */}
                  <div className="date-of-incident d-flex flex-column mt-2 w-full position-relative">
                    <Controller
                      name="dataOfIncident"
                      control={control}
                      rules={{
                        required: "Date of incident is required",

                        validate: (value) => {
                          if (!value) {
                            return "Date of incident is required.";
                          }
                          const input = value?.format
                            ? value.format("DD/MM/YYYY")
                            : value;
                          const parts = input.split("/");

                          if (parts.length !== 3) {
                            return "Please enter a valid date.";
                          }

                          const day = parseInt(parts[0], 10);
                          const month = parseInt(parts[1], 10);
                          const year = parseInt(parts[2], 10);

                          const currentYear = dayjs().year();

                          // 🔹 Year validation FIRST
                          if (!year || parts[2].length !== 4) {
                            return "Please enter a valid year.";
                          }

                          if (year < 2000 || year > currentYear) {
                            return "Please enter a valid year.";
                          }

                          // 🔹 Month validation
                          if (!month || month < 1 || month > 12) {
                            return "Please enter a valid month.";
                          }

                          // 🔹 Day validation basic check
                          if (!day || day < 1 || day > 31) {
                            return "Please enter a valid date.";
                          }

                          // 🔹 Full strict date check
                          const date = dayjs(input, "DD/MM/YYYY", true);

                          if (!date.isValid()) {
                            return "Please enter a valid date.";
                          }

                          // 🔹 Future date
                          if (date.isAfter(dayjs(), "day")) {
                            return "Future dates are not allowed.";
                          }

                          return true;
                        }
                      }}
                      render={({ field, fieldState }) => (
                        <DatePicker
                          value={field.value || null}
                          format="DD/MM/YYYY"
                          minDate={dayjs("2000-01-01")}
                          maxDate={dayjs()}
                          disableFuture
                          disablePortal

                          //   onOpen={() => {
                          //     // Temporarily disable body scroll when calendar is open
                          //     document.body.style.overflow = 'hidden';
                          //   }}

                          //   onClose={() => {
                          //     // Restore body scroll when calendar closes
                          //     document.body.style.overflow = 'unset';
                          //     setTimeout(() => {
                          //       trigger("dataOfIncident");
                          //     }, 0);
                          //   }}

                          onOpen={() => {
                            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
                            document.body.style.overflow = 'hidden';
                            document.body.style.paddingRight = `${scrollBarWidth}px`;
                          }}

                          onClose={() => {
                            document.body.style.overflow = '';
                            document.body.style.paddingRight = '';
                            setTimeout(() => {
                              trigger("dataOfIncident");
                            }, 0);
                          }}

                          onChange={(date) => {
                            field.onChange(date);
                            setTimeout(() => {
                              trigger("dataOfIncident");
                            }, 0);
                          }}

                          sx={{
                            '& .MuiPickersDay-root.Mui-disabled': {
                              color: (theme) =>
                                theme.palette.mode === 'dark' ? '#555555' : undefined,
                              opacity: (theme) =>
                                theme.palette.mode === 'dark' ? 0.4 : undefined,
                            },
                            // ✅ Add styles for calendar popup
                            '& .MuiPickersPopper-paper': {
                              maxHeight: '400px', // Limit calendar height
                              overflowY: 'auto', // Enable scroll within calendar
                            },
                          }}

                          slotProps={{
                            textField: {
                              error: !!fieldState.error,
                              helperText: fieldState.error?.message || "",
                              onBlur: () => {
                                trigger("dataOfIncident");
                              },
                            },
                            popper: {
                              placement: "bottom-start",
                              modifiers: [
                                {
                                  name: "eventListeners",
                                  options: {
                                    scroll: true,   // ✅ allows calendar to move with page scroll
                                    resize: true,
                                  },
                                },
                                {
                                  name: "preventOverflow",
                                  options: {
                                    altAxis: true,
                                    tether: false,
                                  },
                                },
                                {
                                  name: "flip",
                                  options: {
                                    fallbackPlacements: ["top-start"],
                                  },
                                },
                                // ✅ Add hide modifier to better handle scroll
                                {
                                  name: "hide",
                                  enabled: true,
                                },
                              ],
                            },
                          }}
                          className="custom-disabled-datepicker"
                        />
                      )}
                    />

                  </div>
                </div>
              </div>


              {/* COMMENTS */}
              <div className="row mb-3">
                <div className="col-md-12 mt-3">
                  <label htmlFor="comments" className="from-label ">
                    Comments <span className="text-rgbr-red"> *</span>
                  </label>
                  <Controller
                    name="comments"
                    control={control}
                    rules={{ required: "Comments are required" }}
                    render={({ field, fieldState }) => (
                      <QuillComponent
                        control={control}
                        name="comments"
                        placeholder="Enter comments here.."
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        ref={field.ref}
                      />
                    )}
                  />

                  {errors.comments && (
                    <span className="errorMsg">{errors.comments.message}</span>
                  )}
                </div>

                {/* REMARKS */}
                <div className="col-md-12 pt-3 mt-3">
                  <label htmlFor="remarks" className="from-label mb-2">
                    Remarks (optional)
                  </label>
                  <Controller
                    name="remarks"
                    control={control}
                    render={({ field, fieldState }) => (
                      <TextField
                        {...field}
                        multiline
                        rows={3}
                        fullWidth
                        placeholder="Enter any additional remarks..."
                        variant="outlined"
                        className="remarks-input-field"
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                        onBlur={field.onBlur}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                </div>

                {/* FILE UPLOAD */}
                {/* Only show images files */}
                {/* <div className="col-md-12 pt-3 mt-3">
                <label htmlFor="image_evidence" className="from-label ">
                  Upload Image Evidence <span className="text-rgbr-red"></span>
                </label>
             <div className="form-text text-muted small mb-2">
                <strong className="text-secondary">
                  Maximum file size:</strong> 
                  <span className="text-secondary">
                    2MB per image
                  </span>
                  <br />
                  <strong className="text-secondary">
                    Supported formats:</strong> 
                    <span className="text-secondary">
                      JPEG, JPG, PNG, GIF, SVG
                      </span><br />
    {uploadedFile.length > 0 && (
      <span className="text-success">
        <strong className="form-label">{uploadedFile.length} file(s) uploaded</strong>
      </span>
    )}
  </div>

 <FileUpload
  onFileChange={handleFileChange}
  multiple={true}
  accept_type="image/jpeg,image/jpg,image/png,image/gif,image/svg+xml"
  className="mb-4"
  initialFiles={uploadedFile}
  key={isEdit ? `edit-${editData?.appraisal_feedback_id || Date.now()}` : "new"}
  allowRemoveExisting={true}
/>
</div>   */}

                {/* all files show and don't allow unsupported files */}
                <div className="col-md-12 pt-3 mt-3 mb-5">
                  <label htmlFor="image_evidence" className="from-label">
                    Upload Image Evidence{" "}
                    <span className="text-rgbr-red"></span>
                  </label>
                  <div className="form-text text-muted small mb-4">
                    <strong className="text-secondary">
                      Maximum file size:
                    </strong>
                    <span className="text-secondary">2MB per image</span>
                    <br />
                    <strong className="text-secondary">
                      Supported formats:
                    </strong>
                    <span className="text-secondary">
                      JPEG, JPG, PNG, GIF, SVG
                    </span>
                    <br />
                    {/* {uploadedFile.length > 0 && (
      <span className="text-success">
        <strong className="form-label">{uploadedFile.length} file(s) uploaded</strong>
      </span>
    )}  */}
                    {/* {uploadedFile.length > 0 && (
  <span className="text-success">
    <strong className="form-label">
      {uploadedFile.length} file(s) uploaded 
      {" "}({formattedTotalSize})
    </strong>
  </span>
)} */}
                  </div>

                  <ApprisalFileUpload
                    onFileChange={handleFileChange}
                    multiple={true}
                    className="mb-4"
                    initialFiles={uploadedFile}
                    key={
                      isEdit
                        ? `edit-${editData?.appraisal_feedback_id || Date.now()}`
                        : "new"
                    }
                    allowRemoveExisting={true}
                  />
                </div>
              </div>

              <br></br>


              <div className="bg-white position-absolute w-100 bottom-0 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="position-relative add_btn me-3"
                    disabled={
                      isSubmitting || addingNewUser || addingNewProject
                    }
                  >
                    {isSubmitting ? <BtnLoader /> : isEdit ? "Update" : "Add"}
                  </button>

                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                    disabled={
                      isSubmitting || addingNewUser || addingNewProject
                    }
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};



